export default function () {	
	
	$(document).on('click', '.site-header__hamburger', function(){

		$('.site-header__off-canvas, .site-header__hamburger, body').toggleClass('active');

	});

}


// WEBPACK FOOTER //
// ./scripts/components/SetupHamburgerMenu.js